export default __webpack_public_path__ + "sitemap.xml";